var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from "framer";
import { useMemo } from "react";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import theme from "../../designSystem/theme";
import { AssetsList } from "../../store/types";
import { getAssetColor, getAssetDisplay, getAssetLogo, } from "../../utils/asset";
import FilterDropdown from "../Common/FilterDropdown";
import FullscreenMultiselectFilters from "../Common/FullscreenMultiselectFilters";
import MultiselectFilterDropdown from "../Common/MultiselectFilterDropdown";
import EmptyResult from "./Shared/EmptyResult";
import SwitchViewButton from "./Shared/SwitchViewButton";
import YieldCard from "./Theta/YieldCard";
import { VaultSortByFilterOptions, VaultStrategyList, } from "./types";
var FilterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background: ", ";\n  padding: 8px;\n  border-radius: ", ";\n  box-shadow: 4px 8px 40px rgba(0, 0, 0, 0.24);\n\n  & > * {\n    margin-right: 8px;\n\n    &:last-child {\n      margin-right: unset;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  background: ", ";\n  padding: 8px;\n  border-radius: ", ";\n  box-shadow: 4px 8px 40px rgba(0, 0, 0, 0.24);\n\n  & > * {\n    margin-right: 8px;\n\n    &:last-child {\n      margin-right: unset;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), colors.backgroundDarker, theme.border.radius, sizes.md);
var YieldCardsContainer = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: calc(320px * 3);\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-bottom: 40px;\n  padding-inline-start: 0;\n\n  @media (max-width: ", "px) {\n    width: calc(320px * 2);\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  width: calc(320px * 3);\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-bottom: 40px;\n  padding-inline-start: 0;\n\n  @media (max-width: ", "px) {\n    width: calc(320px * 2);\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    justify-content: center;\n  }\n"])), sizes.lg, sizes.md);
var YieldCardContainer = styled(motion.li)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 492px;\n  margin: 40px 15px 0px 15px;\n  margin-block-end: 0px;\n  list-style-type: none;\n"], ["\n  height: 492px;\n  margin: 40px 15px 0px 15px;\n  margin-block-end: 0px;\n  list-style-type: none;\n"])));
var EmptyContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 60vh;\n  width: 100%;\n\n  @media (max-width: ", "px) {\n    height: unset;\n    margin-top: 60px;\n  }\n"], ["\n  height: 60vh;\n  width: 100%;\n\n  @media (max-width: ", "px) {\n    height: unset;\n    margin-top: 60px;\n  }\n"])), sizes.sm);
var ProductCatalogueGridView = function (_a) {
    var setView = _a.setView, onVaultPress = _a.onVaultPress, sort = _a.sort, setSort = _a.setSort, filterStrategies = _a.filterStrategies, setFilterStrategies = _a.setFilterStrategies, filterAssets = _a.filterAssets, setFilterAssets = _a.setFilterAssets, filteredProducts = _a.filteredProducts, vaultAccounts = _a.vaultAccounts, variant = _a.variant;
    var productResults = useMemo(function () {
        if (!filteredProducts.length) {
            return (_jsx(EmptyContainer, { children: _jsx(EmptyResult, { setFilterAssets: setFilterAssets, setFilterStrategies: setFilterStrategies }, void 0) }, void 0));
        }
        return (_jsx(YieldCardsContainer, { children: filteredProducts.map(function (vault) { return (_jsx(YieldCardContainer, __assign({ layout: true, initial: {
                    opacity: 0,
                }, animate: {
                    opacity: 1,
                }, exit: {
                    opacity: 0,
                }, transition: {
                    duration: 0.4,
                    type: "keyframes",
                    ease: "easeOut",
                } }, { children: _jsx(YieldCard, { vault: vault, onClick: function () { return onVaultPress(vault); }, vaultAccount: vaultAccounts[vault] }, void 0) }), vault)); }) }, void 0));
    }, [
        setFilterAssets,
        setFilterStrategies,
        filteredProducts,
        onVaultPress,
        vaultAccounts,
    ]);
    return (_jsxs("div", __assign({ className: "container mt-5 d-flex flex-column align-items-center" }, { children: [_jsxs(FilterContainer, { children: [variant === "desktop" ? (_jsxs(_Fragment, { children: [_jsx(MultiselectFilterDropdown, { values: filterStrategies, options: VaultStrategyList.map(function (strategy) { return ({
                                    value: strategy,
                                    display: strategy,
                                    color: colors.green,
                                }); }), title: "STRATEGY", 
                                // @ts-ignore
                                onSelect: setFilterStrategies }, void 0), _jsx(MultiselectFilterDropdown, { values: filterAssets, options: AssetsList.map(function (asset) {
                                    var Logo = getAssetLogo(asset);
                                    var logo = _jsx(Logo, {}, void 0);
                                    switch (asset) {
                                        case "WETH":
                                            logo = _jsx(Logo, { height: "70%" }, void 0);
                                    }
                                    return {
                                        value: asset,
                                        display: getAssetDisplay(asset),
                                        color: getAssetColor(asset),
                                        textColor: colors.primaryText,
                                        logo: logo,
                                    };
                                }), title: "DEPOSIT ASSET", 
                                // @ts-ignore
                                onSelect: setFilterAssets }, void 0), " "] }, void 0)) : (_jsx(FullscreenMultiselectFilters, { filters: [
                            {
                                name: "strategy",
                                title: "STRATEGY",
                                values: filterStrategies,
                                options: VaultStrategyList.map(function (strategy) { return ({
                                    value: strategy,
                                    display: strategy,
                                    color: colors.green,
                                }); }),
                                // @ts-ignore
                                onSelect: setFilterStrategies,
                            },
                            {
                                name: "asset",
                                title: "DEPOSIT ASSET",
                                values: filterAssets,
                                options: AssetsList.map(function (asset) {
                                    var Logo = getAssetLogo(asset);
                                    var logo = _jsx(Logo, {}, void 0);
                                    switch (asset) {
                                        case "WETH":
                                            logo = _jsx(Logo, { height: "70%" }, void 0);
                                    }
                                    return {
                                        value: asset,
                                        display: getAssetDisplay(asset),
                                        color: getAssetColor(asset),
                                        textColor: colors.primaryText,
                                        logo: logo,
                                    };
                                }),
                                // @ts-ignore
                                onSelect: setFilterAssets,
                            },
                        ], title: "FILTERS", className: "flex-grow-1 " }, void 0)), _jsx(FilterDropdown, { options: VaultSortByFilterOptions, value: sort, 
                        // @ts-ignore
                        onSelect: function (option) {
                            setSort(option);
                        }, buttonConfig: {
                            background: colors.primaryText + "0A",
                            activeBackground: colors.primaryText + "14",
                            paddingHorizontal: 16,
                            paddingVertical: 12,
                            color: colors.primaryText,
                        }, dropdownMenuConfig: {
                            horizontalOrientation: "right",
                            topBuffer: 16,
                        }, className: "flex-grow-1" }, void 0), setView && _jsx(SwitchViewButton, { view: "grid", setView: setView }, void 0)] }, void 0), productResults] }), void 0));
};
export default ProductCatalogueGridView;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ProductCatalogueGridView.js.map